import { AxiosResponse } from 'axios';
import useRequest from '~/hooks/useRequest';
import { useCallback } from 'react';
import * as insuranceServices from '~/services/insurance.service';
import { InsuranceSettings, InsuranceSettingsJSON } from '~/types/Insurance';

export const useInsuranceSettings = () => {
  const {
    request,
    loading: isLoading,
    error,
    data: insuranceSettings,
  } = useRequest<InsuranceSettings>();

  const getInsuranceSettings = useCallback(() => {
    request(async () => {
      const response: AxiosResponse = await insuranceServices.get();
      const output = {
        ...response.data,
        minimum_amount: Number(response.data.minimum_amount).toFixed(2),
      };
      return output;
    });
  }, [request]);

  const updateInsuranceSettings = useCallback(
    (insuranceSettings: InsuranceSettings) => {
      return request(async () => {
        const payload: InsuranceSettingsJSON = {
          ...insuranceSettings,
          minimum_amount: parseFloat(insuranceSettings.minimum_amount),
        };
        const response: AxiosResponse = await insuranceServices.put(payload);
        const { data } = response;
        const output = {
          ...data,
          minimum_amount: Number(data.minimum_amount).toFixed(2),
        };
        return output;
      });
    },
    [request],
  );

  return { getInsuranceSettings, updateInsuranceSettings, error, isLoading, insuranceSettings };
};
